import { Suspense } from 'react';
import { Await, useLoaderData } from 'react-router-dom';
import Loader from '../../components/loader/Loader';
import Chat from '../../components/chat/Chat';

function ChatLoader() {
  const { chatResponse, postResponse } = useLoaderData();

  return (
    <Suspense fallback={<Loader />}>
      <Await
        resolve={Promise.all([chatResponse, postResponse])}
        errorElement={<p>Error loading chats</p>}
      >
        {([chats, posts]) =>
          Array.isArray(chats) && chats.length > 0 ? (
            <Chat chats={chats} posts={posts} />
          ) : (
            <div className="chat">You don't have messages yet</div>
          )
        }
      </Await>
    </Suspense>
  );
}

export default ChatLoader;
